export const API_URL = 'https://happy-thoughts-v2.herokuapp.com/thoughts'

export const LIKES_URL = (thoughtId) => `https://happy-thoughts-v2.herokuapp.com/thoughts/${thoughtId}/like`